export const ClubManufacturers = 
[
    "Callaway Golf",
    "Titleist",
    "TaylorMade",
    "Ping",
    "Cobra",
    "Mizuno",
    "Cleveland",
    "Srixon",
    "Wilson",
    "Bridgestone",
    "PXG",
    "Tour Edge",
    "Honma",
    "XXIO",
    "Hammer"
];

export const DefaultClubLofts = 
{
    "Woods":[
        "8 °",
        "8.5 °",
        "9 °",
        "9.5 °",
        "10 °",
        "10.5 °",
        "11 °",
        "11.5 °",
        "12 °",
        "12.5 °",
        "13 °",
        "13.5 °",
        "3 WD",
        "5 WD",
        "7 WD",
        "9 WD",
        "11 WD"
    ],
    "Hybrids":[
        "1H",
        "2H",
        "3H",
        "4H",
        "5H",
        "6H",
        "7H",
        "8H",
        "9H"
    ],
    "Irons":[
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "PW",
        "AW",
        "SW",
        "LW",
    ],
    "Wedges":[
        "48-10°",
        "50-10°",
        "50-12°",
        "52-10°",
        "52-12°",
        "54-8°",
        "54-10°",
        "54-12°",
        "56-8°",
        "56-10°",
        "56-12°",
        "58-8°",
        "58-10°",
        "58-12°",
        "60-8°",
        "60-10°",
        "60-12°",
        "62-8°",
    ],
    "Putters":[
        "2°",
        "3°",
        "4°",
        "5°"
    ]
}

export const ConvertSubCategoryToPCCategory = (subCat) => {
    let returnVal = "";

    switch(subCat.toLowerCase()){
        case "driver":
        case "drivers":
        case "wood":
        case "woods":
        case "mini driver":
        case "mini drivers":
        case "fairway wood":
        case "fairway woods":
            returnVal = "1";
            break;
        case "hybrid":
        case "hybrids":
            returnVal = "13";
            break;
        case "iron":
        case "irons":
            returnVal = "2";
            break;
        case "wedge":
        case "wedges":
            returnVal = "4";
            break;
        case "putter":
        case "putters":
            returnVal = "3";
            break;
        case "ball":
        case "balls":
            returnVal = "5";
            break;
        default:
            break;
    }

    return returnVal;
}
